import React from 'react'
import './Events.css'
import {motion} from 'framer-motion'

function Events() {
  return (
    <motion.div className="events-container">
    
    {/* <img src="images/Untitleddesign.gif" alt="img" style={{width:"100vw",height:"100vh",position:"relative"}} /> */}
    

{/* cards */}
<br />
<div className="pesent-events" align="center" style={{color:'black'}} >
    <motion.h1 style={{color:'black'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>CURRENT EVENTS</motion.h1>

</div>
<div className="cards">
    {/* <motion.h1 style={{color:'black',textAlign:'center'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>UPCOMING EVENTS</motion.h1> */}
    <hr style={{color:'black'}}/>
    <br />
    <div class="row">
    <div class="col">
    <motion.button class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal1" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Prasthuthi.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>PRASTHUTHI</h5>
            <p class="card-text">BACK! The juxtaposition of a melee of ideas, this paper presentation competition is event for all engineers daring to lend their thoughts a voice.</p>
            <motion.a href="https://bit.ly/Prasthuthi" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
    </motion.button>
    </div>


    <div class="col">
            <motion.div class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal2" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Pradarshana.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>PRADARSHANA</h5>
            <p class="card-text">The atmosphere is a buzz with technical fervour and art! A poster presentation for all vibrant engineers..!!!</p>
            <motion.a href="https://bit.ly/OUPradarshana" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
        </motion.div>
    </div>
    </div>

    <div class="row">
    <div class="col">
    <motion.div class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal3" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Krithi.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>KRITHI</h5>
            <p class="card-text">Are you surcharged with the versatility of the erudite engineer? then krithi beckons this project presentation event, guaranteed to set the stage for cognizance.</p>
            <motion.a href="https://bit.ly/OUKrithi" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
    </motion.div>
    </div>

    <div class="col">
            <motion.div class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal4" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Trishna.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>TRISHNA</h5>
            <p class="card-text">Gear up to tickle your "Quizzotic" bond. This technocrat's revelation is to an enigmatic quiz challenge of a life time. So be there..</p>
            <motion.a href="https://bit.ly/OUTrishna" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
        </motion.div>
    </div>
    </div>


    <div class="row">
    <div class="col">
    <motion.div class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal5" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Shikshana.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>SHIKSHANA</h5>
            <p class="card-text">What is 5G? What is SDR? all these questions and more will be answered in this classroom with a difference, in AAKRUTHI's prestigious guest lecture!!</p>
            <motion.a href="" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
    </motion.div>
    </div>

    <div class="col">
            <motion.div class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal6" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Medha.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>MEDHA</h5>
            <p class="card-text">Your favourite programming event is back with a bang!! The stage is set for decrypting the ultimate unimaginable codes of the decade.</p>
            <motion.a href="https://bit.ly/OUMedha" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
        </motion.div>
    </div>
    </div>


    <div class="row">
    <div class="col">
    <motion.div class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal7" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Chanakya.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>CHANAKYA</h5>
            <p class="card-text">It's quiz time!! Floor the audience with spectacular business acumen, as this challenge is a diorama- You would not want to miss!</p>
            <motion.a href="https://bit.ly/OUChanakya" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
    </motion.div>
    </div>

    <div class="col">
            <motion.div class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal8" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Yantra.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>YANTRA</h5>
            <p class="card-text">In this bionic battlefield get ready for hair rising war of the mean machines... An invigorating robotic event..!!</p>
            <motion.a href="https://bit.ly/OUYantra" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
        </motion.div>
    </div>
    </div>



    <div class="row">
    <div class="col">
    <motion.div class="card shadow-lg p-3 mb-5 rounded" type="button" data-bs-toggle="modal" data-bs-target="#exampleModal9" style={{alignItems:'center'}} initial={{y:300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}>
          <img src="images/Laghuchitra.png" class="card-img-top" alt="img" style={{height:"200px",width:"200px"}}/>
          <div class="card-body">
            <h5 class="card-title" style={{fontSize:'30px'}}>LAGHUCHITRA</h5>
            <p class="card-text">Lights! Camera! Action! Are you a film maker with creative ideas? The laghuchitra provides you a platform to showcase your talent..</p>
            <motion.a href="https://bit.ly/Laghuchitra" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
          </div>
    </motion.div> 
    </div>
    </div>

    <div className="past-events" align="center">
    <motion.h1 style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>PAST EVENTS</motion.h1>
    <hr />
    <motion.img src="images/ethical.webp.jpg" alt="img" className="event-img" initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br />
    <motion.div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel" initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="images/wk1.jpg" class="d-block" width="100%" alt="img"/>
    </div>
    <div class="carousel-item">
      <img src="images/wk2.jpg" class="d-block" width="100%" alt="img"/>
    </div>
    <div class="carousel-item">
      <img src="images/wk3.jpg" class="d-block" width="100%" alt="img"/>
    </div>
    <div class="carousel-item">
      <img src="images/wk4.jpg" class="d-block" width="100%" alt="img"/>
    </div>
    <div class="carousel-item">
      <img src="images/wk5.jpeg" class="d-block" width="100%" alt="img"/>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</motion.div><hr />
<motion.img src="images/iotworkshopiete.png" alt="img" className="event-img" initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br />
    <motion.h4 className="event-info" initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>AAKRUTHI 2022 in association with IETE Student Forum OUCE is organising a two day workshop on IoT for Emerging Applications <br /> <br />

        Date: 22nd and 23rd April <br /> 
        Venue: ECE Department, OUCE <br /> 
        Last date of registration: 21 April <br /> <br />

        Instructors: <br /> <br />

        Prof. L. Nirmala Devi, <br />
        Hod, ECE Dept., OUCE <br /><br />

        Dr. M. Shyam Sunder,<br />
        Asst. Prof., ECE Dept., OUCE <br /><br />

        For further details, Contact: <br />
        Hrushikesh : 8074636830 <br />
        Arun Mohan: 9014022877 <br />
        Vishwanath: 9390322914</motion.h4>
        <br />
        

    </div>
     
</div>
{/* <!-- Modal --> */}
<div class="modal fade" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>PRASTHUTHI</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    <motion.img src="images/PRASTHUTHU.png" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br />
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}> <br /> REGISTRATION LINK : 

<a href="https://bit.ly/Prasthuthi">https://bit.ly/Prasthuthi</a> <br /> <br />

We're sure you've heard about paper presentations, but this is the one you wouldn't want to miss. Have a plethora of ideas and topics that you wish to present? but don't have a platform? Well we have just the right solution.  <br />
PRASTHUTHI - A paper presentation competition, provides an emphatic platform for presenting and communicating ideas. There are loads of voracious competitors out there, so come down and prove you're the best. <br />
Stay tuned ..! <br /><br />

Event Details : <br />
• Each team should have minimum of 1 and atmost 4 members, belonging to the same or different colleges. <br />

• The papers(abstract) have to be in the IEEE format not exceeding 6 pages. <br />

* Strictly the paper should be in IEEE format, else will be rejected. <br />

• The paper and any part of it must not be plagiarized from “white” papers. <br />

• Soft copy of the paper must be mailed to aakruthi2k22@gmail.com 28th April, 2022, 11:00A.M. The subject should be “Prasthuthi- Topic Name”. <br />

• The selected teams have to pay a participation fee of Rs. 300/- per head for Offline mode as well as Rs.150/- per head for Online mode. <br />

• On the event day, all the participants ‘must’ have ID cards of their respective colleges. <br />

• The participating team would be given 10 minutes to present their paper (in which all participants have to speak) and 2 minutes are allotted for queries.
 <br />
• Judges decision will be final and further queries on the matter shall not be entertained. <br />

a) Originality of the idea <br />

b) Presentation skills <br />

c) Practical scope and extent of implementation <br />

d) Team work <br />

 <br />CONTACT <br />
P. Likhitha : 9963347321 <br />
S. Ruthwik: 8977633857 <br />
P. Sushma : 7287846244</motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="https://bit.ly/Prasthuthi" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>PRADARSHANA</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    <motion.img src="images/PRADARSHANA1.png" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}> <br /> PRADARSHANA -Poster Presentation <br /><br />

REGISTRATION LINK : <a href="https://bit.ly/OUPradarshana">https://bit.ly/OUPradarshana</a> <br /> <br />
" Design is intelligence made     visible" <br /> <br />

Design creates culture. Culture shapes values. Values determine the future. <br />
If you have great designing skills, then this can be your best choice. <br /> <br />

Come with your best, amplify your experience and win exciting prizes. <br />

Register | Design | Present | Win <br /> <br />

EVENT DETAILS <br />
• Each team should have minimum of 1 and atmost 4 members, belonging to the same or different colleges.
<br />
• Participation fee is Rs. 300/- per head for Offline mode as well as Rs.150/- per head for Online mode.
<br />
• On the event day, all the participants ‘must’ have ID cards of their respective colleges.
<br />
• Judges decision will be final and further queries on the matter shall not be entertained.
<br /> <br />
CONTACT <br />
K. Navdeep Chintu : 9502073414 <br />
J. Vishwanath : 9390322914 <br />
R. Sai Vineela : 9390250439</motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="https://bit.ly/OUPradarshana" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="exampleModal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"> 
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>KRITHI</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    <motion.img src="images/KRITHI1.png" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}> <br /> KRITHI - Project presentation <br /> <br />

REGISTRATION LINK :-
<a href="https://bit.ly/OUKrithi">https://bit.ly/OUKrithi</a> <br />
"Advancing technology for the betterment of Humanity". <br /> <br />

Are you willing to unleash the engineer within you? But waiting for a better platform?...Well,we have something that will land you straight into your priority list!AAKRUTHI presents you KRITHI, the Project Presentation competition, where people like you with excellent technical skills have the opportunity to showcase your talent and gain pristine exposure. <br />
. <br />
. <br />
. <br />
Let's explore your talent. <br /> <br />

EVENT DETAILS: <br /> <br />

*Each team should have minimum of 1 and at most 4 members, belonging to the same or different college. <br />

• Soft copy of the abstract must be mailed to aakruthi2022@gmail.com by April 28 th,2022, 11:00 A.M. The subject should be “Krithi- Topic Name”. <br />

• The participation fee is Rs. 300/- per head(offline with food) Rs. 150/-( offline without food) Rs.150/- (online) <br />

• On the event day, all the participants ‘must’ have ID cards of their respective colleges. <br />

• Judges decision will be final and further queries on the matter shall not be entertained. <br />

• The following parameters will be taken into consideration for judgement: <br />
a.Execution of the project. <br />
b.Presentation skills. <br />
c.Good performance in queries session. <br /> <br />

CONTACT: <br />
M. Sai Ruthvik : 6304254623 <br />
Ch. Rakshith : 9000685929 <br />
Gaffar : 9618975440 <br />
E. Deepthi : 9059798727

        </motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="https://bit.ly/OUKrithi" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="exampleModal4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>TRISHNA</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    <motion.img src="images/TRISHNA1.png" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br />
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>TRISHNA – Technical Quiz <br /><br />
REGISTRATION LINK : <a href="https://bit.ly/OUTrishna">https://bit.ly/OUTrishna</a> <br /><br />

Greetings everyone! <br />

For all the technical enthusiasts out there, It's quiz time folks!!! coz  _AAKRUTHI 2020_presents for you  TRISHNA , the technical quiz. <br />

Do you see in you one of those nerdy brainiacs, whose nervous systems process more facts than your lowly neighbours? To put it plainer, is quizzing your forte? Then Trishna gives you the clarion call to join its conglomeration of whiz kids. <br />

A brilliant opportunity for you to showcase your talent and celebrate the best of technology whilst inserting knowledge, self improvement and of course appreciating the performance of superlative among the rest. <br /><br />

CONTACT <br />
P. Vikram : 9652206771 <br />
G. Vaishnavi : 9603208648 <br />
Ch. Raju : 9652554901</motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="https://bit.ly/OUTrishna" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="exampleModal5" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>SHIKSHANA</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    {/* <motion.img src="images/PRASTHUTHU.png" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br /> */}
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>"Anyone who keeps learning stays young"-  Henry Ford <br /><br />

Artificial Intelligence, Metaverse, 5G technology, Augmented reality,..... I'm sure you're aware of such gigantic and advancing technologies. Want to dive more into these stuff? Then you've come to the right place!

Shikshana is a guest lecture conducted as a part of Aakruthi 2022, where you will learn about the latest technologies and innovations, taught by the experienced companies!

Don't miss this amazing opportunity to open the windows of your brain and enhance your skills!</motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="exampleModal6" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>MEDHA</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    <motion.img src="images/MEDHA1.png" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br />
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}> <br /> MEDHA  - Programming Quiz <br /> <br />
REGISTRATION LINK : <a href="https://bit.ly/OUMedha">https://bit.ly/OUMedha</a> <br />
Hello Amigos!!! <br />
Programming is neither just a Swamp nor an Ocean it’s an entire world. Where anything and every thing is under your control . <br />
Can you reach the pinnacle and shine or not?? Let’s find out..... <br />
Here is a call to all the GEEK’S out there
We provide you a platform
MEDHA <br /><br />
 All you need to do is to showcase your skill cause luck doesn't matter ...!!! <br /><br />

CONTACT: <br />
V. Srihitha : 8019199047 <br />
T. Prasanth : 7995262107 <br />
Sivapriya Srinivasan: 9966200326</motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="https://bit.ly/OUMedha" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="exampleModal7" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>CHANAKYA</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    <motion.img src="images/IMG-20220426-WA0040.jpg" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br />
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}> <br /> REGISTRATION LINK:

 <a href="https://bit.ly/OUChanakya">https://bit.ly/OUChanakya</a> <br />

CHANAKYA- Business quiz <br /> <br />

" You don’t have to see the whole staircase , just take the first step”
              – Martin Luther King
<br />
Do you wish to step into the field of business? Do you want to explore the world of management, and see where you stand? If yes, we bring to you CHANAKYA , a business Quiz , that might just be the perfect step before you embark upon the journey of management. <br /> <br />

Hurry up to register, and get ready to be a part of one of the most fun yet competitive events that you 
might have ever come across!! <br /> <br />


NOTE: <br />
• Quiz contains two rounds. <br />
• Spot registration fee of Rs 100/- per participant would be collected. <br />
• Judges decision will be final and further queries on the matter shall
not be entertained. <br /> <br />

CONTACT: <br />
SHIVANGI DWIVEDI - 6303187924 <br />
VAISHNAVI - 7702177583 <br />
AASHISH REDDY - 8688996303</motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="https://bit.ly/OUChanakya" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="exampleModal9" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>LAGHUCHITRA</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    <motion.img src="images/LAGHUCHITRA1.png" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br />
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>LAGHUCHITRA - SHORT FILM CONTEST <br /> <br />
REGISTRATION LINK: <a href="https://bit.ly/Laghuchitra">https://bit.ly/Laghuchitra</a> <br /> <br />
A large chunk of the current marquee filmmakers have started their quest for greatness through short films.
AAKRUTHI is giving a platform for all the film enthusiasts to help you get close to the greatness you deserve through a short film contest LAGHUCHITRA where you can showcase your creativity and interest towards film making....!
<br /><br />
CONTACT <br />
D. Satvik : 7337261662 <br />
G. Deekshith : 9848417489
</motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="https://bit.ly/Laghuchitra" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 

<div class="modal fade" id="exampleModal8" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="exampleModalLabel"  style={{color:'rgb(125, 131, 125)'}}>YANTRA</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
    <motion.img src="images/YANTRA1.png" alt="img" className="event-img" style={{width:"100%",height:'100%'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}} whileHover={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}} whileTap={{scale:1.05,textShadow:"0px 0px 1px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",color:'white',backgroundColor:'black'}}/>
    <br /><br />
        <motion.p style={{color:'black'}} initial={{y:-300}} whileInView={{y:0,transition:{type:'spring',bounce:0.6,duration:0.8}}} viewport={{once:true}}>
        YANTRA-Robotic championship <br /><br />
REGISTRATION LINK : <a href="https://bit.ly/OUYantra">https://bit.ly/OUYantra</a> <br />

"War doesn't determine who is right - only who is left". A good news to all robo nerds to show off their ideas in this building field. Express the supremacy inside the ring to pave for success....AAKRUTHI presents to you 'YANTRA' , the robotics competition; an opportunity to compete for  higher stakes and rewards. <br /><br />

For event details visit our website:  <br />
www.aakruthi.org <br /> <br />

Judging criteria: <br />
Will be explained to the participants at the time of Event. <br />
 <br />
Contact Details: <br />
Arun Mohan : 9014022877 <br />
Vishwashree : 8519886651 <br />
Anusha : 8465989332 <br />
M. Ajay : 8897830367
        </motion.p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
        <motion.a href="https://bit.ly/OUYantra" target="_blank" rel="noreferrer" class="btn btn-dark" whileHover={{scale:1.1,textShadow:"0px 0px 8px rgb(225,225,225)",boxShadow:"0px 0px 8px rgb(225,225,225)",backgroundColor:'white',color:'black'}}>REGISTER NOW</motion.a>
        
      </div>
    </div>
  </div>
</div> 
    </motion.div>
  )
}

export default Events